import { useFormikContext } from 'formik';
import { t } from 'i18next';
import { get } from 'lodash';
import { FC } from 'react';
import { Iasset2LangValue } from 'src/models';
import { POST_WITH_ID } from '@brickwise/asset-validation/dist/asset/assetData';
import { useAsset } from 'src/context-providers/AssetContext';

interface Props {
  fieldName: string;
  defaultValue?: string;
}

const returnCurrentLangTranslationCode = (language: string) => {
  const table = {
    en: 'eng',
    de: 'deu',
  };
  return table[language as keyof typeof table];
};

const useNomenclatureDict = () => {
  const formik = useFormikContext<POST_WITH_ID>();

  if (formik?.values.descriptions?.nomenclature) {
    return formik.values.descriptions.nomenclature;
  }

  const { asset } = useAsset();

  return asset?.descriptions?.nomenclature;
};

export const NomenclatureLabel: FC<Props> = ({ fieldName, defaultValue }) => {
  const nomenclatureDict = useNomenclatureDict();
  const currentNomenclature = get(nomenclatureDict, fieldName) as Iasset2LangValue[];
  if (!currentNomenclature || !Array.isArray(currentNomenclature) || currentNomenclature.length === 0) {
    return <>{defaultValue}</>;
  }

  const siteLanguageCode = t('currentLanguageCode');
  const languageCodeToLookFor = returnCurrentLangTranslationCode(siteLanguageCode);
  const filtered = currentNomenclature.find((item) => item.lang === languageCodeToLookFor);
  if (!filtered || !filtered.value || !filtered.value === undefined || filtered.value === '') {
    return <>{defaultValue}</>;
  }

  return <>{filtered.value}</>;
};
